import * as Yup from "yup";

export const changePasswordValidation = Yup.object().shape({
  previousPassword: Yup.string().required("Campo Obligatorio"),
  newPassword: Yup.string().required("Campo Obligatorio").min(6, "La contraseña debe tener un mínimo de 6 caracteres").max(32, "La contraseña debe tener un máximo de 32 caracteres"),
  repeatedNewPassword: Yup.string().required("Campo Obligatorio").equals([Yup.ref("newPassword")], "La nueva contraseña y su confirmación no coinciden").max(32, "La contraseña debe tener un máximo de 32 caracteres"),
});